import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config as variantConfig } from '@/pageConfig/homeowners/us/bottom-sticky-cta';
import { HomeownersPageTemplate } from '@/pageTemplate/HomeownersPageTemplate';
import { useEffect } from 'react';

export default function HomeownersPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  useEffect(
    () =>
      trackEventWithGeolocation('homeowners_page.viewed', {
        experiment: 'bottom_sticky_cta_on',
      }),
    [],
  );

  return <HomeownersPageTemplate config={variantConfig} />;
}
